import './PopoverSelector.scss';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { PopoverSelectorSearch } from './PopoverSelectorSearch';
import { Tooltip } from 'antd';
import { When } from 'react-if';
import { CheckOutlined, LoadingOutlined, SelectOutlined, SettingOutlined } from '@ant-design/icons';
import { haltClickEventPropagation, haltEvent } from '@lib/events';
import React, { useCallback, useEffect, useState } from 'react';
export function PopoverSelector({ children, className, footer, itemRender, listItems, manageRoute, onDeselect, onOpen, onOpenChange, onSearch, onSelect, placeholder, selectedIds = [], singleSelect, trigger = 'hover' }) {
    const [addingId, setAddingId] = useState(-1);
    const [removingId, setRemovingId] = useState(-1);
    const handleOnClick = useCallback((e, isSelected, item) => {
        e.preventDefault();
        e.stopPropagation();
        if (isSelected) {
            if (!singleSelect) {
                setRemovingId(item.id);
            }
            onDeselect(item);
        }
        else {
            if (!singleSelect) {
                setAddingId(item.id);
            }
            onSelect(item);
        }
    }, [onDeselect, onSelect, singleSelect]);
    const handleOpen = useCallback((e, id) => {
        e.preventDefault();
        e.stopPropagation();
        if (onOpen) {
            onOpen(id);
        }
    }, [onOpen]);
    useEffect(() => {
        if (selectedIds.includes(addingId)) {
            setAddingId(-1);
        }
        if (!selectedIds.includes(removingId)) {
            setRemovingId(-1);
        }
    }, [addingId, removingId, selectedIds, setAddingId, setRemovingId]);
    const showSearch = Boolean(onSearch);
    const showManage = Boolean(manageRoute);
    const showHeader = showSearch || showManage;
    return (React.createElement("div", { className: 'popover-selector' },
        React.createElement(Tooltip, { arrow: false, onOpenChange: onOpenChange, overlayClassName: classNames('popover-selector-panel', className), placement: 'bottomRight', title: React.createElement("div", { onClick: haltClickEventPropagation, onMouseDown: haltEvent, onMouseUp: haltEvent },
                showHeader &&
                    React.createElement("div", { className: 'popover-header' },
                        showSearch && React.createElement(PopoverSelectorSearch, { onSearch: onSearch, placeholder: placeholder }),
                        showHeader &&
                            React.createElement(Link, { className: 'manager-link', to: manageRoute !== null && manageRoute !== void 0 ? manageRoute : '' },
                                React.createElement(SettingOutlined, null))),
                React.createElement("div", { className: 'selector-list' }, listItems.map((item) => {
                    const { id } = item;
                    const isSelected = selectedIds.includes(id);
                    const loading = id === addingId || id === removingId;
                    return (React.createElement("div", { className: `clickable-row ${isSelected || loading ? 'selected' : ''}`, key: id, onClick: (e) => handleOnClick(e, isSelected, item) },
                        React.createElement("div", { className: 'list-item' },
                            React.createElement("div", null, itemRender(item)),
                            React.createElement(When, { condition: Boolean(onOpen) },
                                React.createElement(SelectOutlined, { className: 'open-item', onClick: (e) => handleOpen(e, id) }))),
                        React.createElement("div", { className: 'selected-check' },
                            React.createElement(When, { condition: !loading && isSelected },
                                React.createElement(CheckOutlined, null)),
                            React.createElement(When, { condition: loading },
                                React.createElement(LoadingOutlined, null)))));
                })),
                footer), trigger: trigger }, children)));
}
